export default {
  stockImages: state => state.stockImages
}
